import { Box, Button, Flex, Text } from 'pcln-design-system'

export default function Intro({ onButtonClick }: { onButtonClick: () => void }) {
  return (
    <Box color='primary' pt={[6, null, 0]}>
      <Box m='auto' maxWidth='768px' pt={5} pb={[5, null, 6]} px={[3, null, null, 5, 0]}>
        <Text mb={4} color='#FFF100' fontSize={4} textAlign='center' style={{ letterSpacing: '2px' }}>
          The ridiculously easy loyalty program
        </Text>
        <Box m='auto' pb={4}>
          <Text
            style={{ letterSpacing: '1px' }}
            color='text.lightest'
            fontSize={[1, null, null, 2]}
            lineHeight='2'
            textAlign='center'
          >
            Advance towards the next VIP tier with every trip you take! It’s simple — each completed booking
            is your key to even more benefits.
          </Text>
        </Box>
        <Flex flexDirection='column'>
          <Button
            onClick={() => {
              onButtonClick()
            }}
            m='auto'
            borderRadius='xsm'
            color='background.lightest'
          >
            <Text fontSize={[1, null, null, 2]} color='primary'>
              Become a member for free
            </Text>
          </Button>
          <Text color='text.lightest' fontSize={1} mt={3} mx='auto' textAlign='center'>
            Already have a Priceline account? You&#39;re already VIP!{' '}
            <Button
              variation='link'
              color='text.lightest'
              onClick={() => {
                onButtonClick()
              }}
              style={{ textDecoration: 'underline' }}
            >
              Sign in
            </Button>{' '}
            to see your status.
          </Text>
        </Flex>
      </Box>
    </Box>
  )
}
